import type { AxiosResponse } from 'axios';
import { adminAxios } from 'utils/adminAxios';
import { adminsApi } from './api';

export const getAdminsMe = async (): Promise<AxiosResponse> => {
  return await adminAxios.get(`${adminsApi.path}/me`);
};

export type AdminsMePasswordRequest = Required<{
  currentPassword: string;
  password: string;
  passwordConfirmation: string;
}>;

export const putAdminsMePassword = async (
  data: AdminsMePasswordRequest
): Promise<AxiosResponse> => {
  return await adminAxios.put(`${adminsApi.path}/me/password`, data);
};
